export default __webpack_public_path__ + "static/media/intro-phone.f5051fa3.png";